module.exports = __webpack_public_path__ + "img/moreno.7cd1b647.png";